import { Divider } from 'components/commons/Divider'
import Page from 'components/Page'
import { GetStaticProps } from 'next'

import { Link } from 'components/commons/Link'
import Layout from 'components/layouts/Layout'
import { useTranslations } from 'next-intl'
import { useRouter } from 'next/router'
import { ReactElement } from 'react'
import { localizePath } from 'src/utils/localizedRoutes'

function TermsAndConditions() {

  const t = useTranslations("termos-e-condicoes")
  const router = useRouter()
  const privacyPolicyHref = localizePath("/politica-de-privacidade", router.locale)

  return (
    <Page id='terms-and-conditions' title={t("metadata-title")} description={t("metadata-description")} className='bg-gray' footer>
      <div className='w-full mx-auto max-w-6xl'>
        <div className='w-full text-center'>
          <h1 className='text-7xl md:text-10xl font-bold md:font-extrabold mb-6 text-center'>
            {t("title")}
          </h1>
          <Divider />
        </div>

        <p>{t("summary-1")}</p>
        <p>{t("summary-2")} <Link href={privacyPolicyHref} text={t("privacy-policy")} variant='plain' prefetch={false} />.</p>
        <p>{t("summary-3")}</p>

        <p className='text-4xl font-semibold mt-6'>{t("site-content-title")}</p>
        <p>{t("site-content-1")}</p>
        <p>{t("site-content-2")}</p>

        <p className='text-4xl font-semibold mt-6'>{t("license-title")}</p>
        <p>{t("license-1")}</p>
        <p>{t("license-2")}</p>
        <p>- {t("license-3")}</p>
        <p>- {t("license-4")}</p>
        <p>{t("license-5")}</p>
        <p>{t("license-6")}</p>

        <p className='text-4xl font-semibold mt-6'>{t("limit-responsability-title")}</p>
        <p>{t("limit-responsability-1")}</p>
        <p>{t("limit-responsability-2")}</p>
        <p>{t("limit-responsability-3")}</p>

        <p className='text-4xl font-semibold mt-6'>{t("website-changes-title")}</p>
        <p>{t("website-changes-1")}</p>

        <p className='text-4xl font-semibold mt-6'>{t("links-and-bindings-title")}</p>
        <p>{t("links-and-bindings-1")}</p>
        <p>{t("links-and-bindings-2")}</p>

        <p className='text-4xl font-semibold mt-6'>{t("personal-data-title")}</p>
        <p>{t("personal-data-1")} <Link href={privacyPolicyHref} text={t("personal-data-2")} variant='plain' />.</p>

      </div>
    </Page>
  )
}

export const getStaticProps: GetStaticProps = async context => {
  return {
    props: {
      context,
      messages: (await import(`../lang/${context.locale}.json`)).default
    }
  }
}

TermsAndConditions.getLayout = function getLayout(page: ReactElement) {
  return (
    <Layout variant='secondary'>
      {page}
    </Layout>
  )
}

export default TermsAndConditions
